const styles = {
  PaletteFooter: {
    backgroundColor: 'white',
    height: '5vh',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontWeight: 'bold'
  },
  PaletteEmoji: {
    fontSize: '1.5rem',
    margin: '0 1rem'
  }
};

export default styles;
